<template>
  <div>
    <div :id="'apparatus-with-multiple-subscriptions' + apparatus.apparatusId" role="dialog" class="modal fade show">
      <div class="modal-dialog modal-dialog-centered">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="far fa-exclamation-triangle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeApparatusWithMultipleSubscriptionsModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                {{
                  $t('xApparatusHasMultipleSubsBodyText', {
                    0: getApparatusTypeAsString,
                    1: apparatus.preferredDealerName,
                    2: currentPremiumSubscription.product?.name,
                    3: $moment(currentPremiumSubscription.renewalDate).format($t('xShortDate'))
                  })
                }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <button type="button" @click="goToCancelModal()" class="btn btn-primary">
              {{ $t('xCancelPlanLowercase') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <div
      :id="'home-premium-apparatus-with-multiple-subscriptions' + apparatus.apparatusId"
      role="dialog"
      class="modal fade show"
    >
      <div class="modal-dialog modal-dialog-centered">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="far fa-exclamation-triangle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeHomePremiumApparatusWithMultipleSubscriptionsModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                {{
                  $t('xAlreadyManagedPleaseRemoveApparatus', {
                    0: apparatus.name,
                    1: apparatus.preferredDealerName,
                    2: getApparatusTypeAsString,
                    3: currentPremiumSubscription.product?.name
                  })
                }}
              </div>
            </div>
          </div>
          <ModalFooter>
            <button type="button" @click="goToRemoveModal()" class="btn btn-primary">
              {{ $t('xRemoveFromPlan') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <div
      :id="'apparatus-with-multiple-subscriptions-mobile-platform' + apparatus.apparatusId"
      role="dialog"
      class="modal fade show"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 560px;">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="fa fa-exclamation-circle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeApparatusWithMultipleSubscriptionsMobilePlatformModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  {{
                    $t('xApparatusHasMultipleSubsOnMobileBodyText1', {
                      0: apparatus.name,
                      1: apparatus.preferredDealerName,
                      2: currentPremiumSubscription.product?.name,
                      3: $moment(currentPremiumSubscription.renewalDate).format($t('xShortDate'))
                    })
                  }}
                </div>

                <div v-if="currentPremiumSubscription.store === subscriptionStoreTypesApple">
                  <div>
                    {{ $t('xApparatusHasMultipleSubsOnAppleBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://account.apple.com/account/manage/section/subscriptions.' }}
                  </div>
                </div>
                <div v-if="currentPremiumSubscription.store === subscriptionStoreTypesGoogle">
                  <div>
                    {{ $t('xApparatusHasMultipleSubsOnAndroidBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://play.google.com/store/account/subscriptions.' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter>
            <button
              type="button"
              @click="closeApparatusWithMultipleSubscriptionsMobilePlatformModal()"
              class="btn btn-primary flex flex-grow-1"
            >
              {{ $t('xDone') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>

    <div
      :id="'remove-apparatus-with-multiple-subscriptions-mobile-platform' + apparatus.apparatusId"
      role="dialog"
      class="modal fade show"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 560px;">
        <span tabindex="0"></span>
        <div tabindex="-1" class="modal-content">
          <header class="modal-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col">
                <h2 class="modal-title">
                  <i class="fa fa-exclamation-circle colorOrange mr-1" />
                  {{ $t('xYourAccountNeedsAttentionHeader') }}
                </h2>
              </div>
              <div class="float-right col-auto">
                <button
                  type="button"
                  class="btn btn-icon-button--gray btn-icon-button"
                  @click="closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
          </header>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="mb-3">
                  {{
                    $t('xRemoveApparatusHasMultipleSubsOnMobileBodyText1', {
                      0: apparatus.name,
                      1: apparatus.preferredDealerName,
                      2: getApparatusTypeAsString,
                      3: currentPremiumSubscription.product?.name
                    })
                  }}
                </div>

                <div v-if="currentPremiumSubscription.store === subscriptionStoreTypesApple">
                  <div>
                    {{ $t('xRemoveApparatusHasMultipleSubsOnAppleBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://account.apple.com/account/manage/section/subscriptions.' }}
                  </div>
                </div>
                <div v-if="currentPremiumSubscription.store === subscriptionStoreTypesGoogle">
                  <div>
                    {{ $t('xRemoveApparatusHasMultipleSubsOnAndroidBodyText2') }}
                  </div>
                  <div>
                    {{ 'https://play.google.com/store/account/subscriptions.' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter>
            <button
              type="button"
              @click="closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal()"
              class="btn btn-primary flex flex-grow-1"
            >
              {{ $t('xDone') }}
            </button>
          </ModalFooter>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'

export default {
  props: ['apparatus', 'currentPremiumSubscription'],
  computed: {
    subscriptionStoreTypesApple() {
      return Object.values(Constants.SubscriptionStoreTypes).indexOf('Apple')
    },
    subscriptionStoreTypesGoogle() {
      return Object.values(Constants.SubscriptionStoreTypes).indexOf('Google')
    },
    getApparatusTypeAsString() {
      switch (this.apparatus?.type) {
        case Constants.HsbApparatusType:
          return this.$t('xGeneratorLowercase')
        case Constants.FuelTankApparatusType:
          return this.$t('xFuelMonitorLowercase')
        default:
          return ''
      }
    }
  },
  methods: {
    closeApparatusWithMultipleSubscriptionsModal() {
      document.getElementById('apparatus-with-multiple-subscriptions' + this.apparatus.apparatusId).style.display =
        'none'
    },
    closeHomePremiumApparatusWithMultipleSubscriptionsModal() {
      document.getElementById(
        'home-premium-apparatus-with-multiple-subscriptions' + this.apparatus.apparatusId
      ).style.display = 'none'
    },
    closeApparatusWithMultipleSubscriptionsMobilePlatformModal() {
      document.getElementById(
        'apparatus-with-multiple-subscriptions-mobile-platform' + this.apparatus.apparatusId
      ).style.display = 'none'
    },
    closeRemoveApparatusWithMultipleSubscriptionsMobilePlatformModal() {
      document.getElementById(
        'remove-apparatus-with-multiple-subscriptions-mobile-platform' + this.apparatus.apparatusId
      ).style.display = 'none'
    },
    goToCancelModal() {
      this.$router.push({
        name: 'settingsSubscriptions',
        params: { apparatusMultipleSubs: this.apparatus }
      })
      this.closeApparatusWithMultipleSubscriptionsModal()
    },
    goToRemoveModal() {
      this.$router.push({
        name: 'settingsSubscriptions',
        params: { apparatusMultipleSubs: this.apparatus }
      })
      this.closeHomePremiumApparatusWithMultipleSubscriptionsModal()
    }
  }
}
</script>
